module.exports = __webpack_public_path__ + "static/media/19.a211f211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DeconstructedNews/19.jpg
// module id = 296
// module chunks = 0